import { createTextVNode as p, Fragment as u, Comment as y } from "vue";
function i(f, t = !0, n = []) {
  return f.forEach((r) => {
    if (r !== null) {
      if (typeof r != "object") {
        (typeof r == "string" || typeof r == "number") && n.push(p(String(r)));
        return;
      }
      if (Array.isArray(r)) {
        i(r, t, n);
        return;
      }
      if (r.type === u) {
        if (r.children === null)
          return;
        Array.isArray(r.children) && i(r.children, t, n);
      } else {
        if (r.type === y && t)
          return;
        n.push(r);
      }
    }
  }), n;
}
export {
  i as flatten
};
